import { Card } from '@mantine/core';
import type { ReactNode } from 'react';

interface FormCardProps {
  children: ReactNode;
}

/**
 * Der weisse Inhaltsrahmen eines Meldeformulars.
 *
 * Unfall- und Umweltdaten haben ihn seit jeher — dort sitzt er als `<Card padding="lg"
 * radius="md" withBorder>` am Tab-Panel (`AccidentDataForm.tsx`, `EnvironmentalDataForm.tsx`).
 * Die drei Marktformulare haben keine Reiter und rendern deshalb bis Plan 23-09 direkt auf den
 * grauen Seitenhintergrund; genau das hat die Nutzerabnahme von Phase 23 beanstandet.
 *
 * Bewusst ohne eigene Farb- oder Randwerte: `padding`, `radius` und `withBorder` sind dieselben
 * drei Mantine-Props wie bei den Referenzformularen, alles Weitere kommt aus dem Theme. Ein
 * nachgebauter Rahmen mit eigenen Hex-Werten wuerde beim naechsten Theme-Wechsel auseinanderlaufen
 * — und die Gleichheit mit den Referenzformularen ist hier die ganze Anforderung.
 *
 * Der gelbe Summenbalken gehoert NICHT hier hinein: er steht im Sketch als eigener Block unter dem
 * Abschnitt, nicht in dessen Rahmen.
 */
export function FormCard({ children }: FormCardProps) {
  return (
    <Card padding="lg" radius="md" withBorder>
      {children}
    </Card>
  );
}
